<script>
import Layout from "@/views/layouts/LayoutAdmin";

export default {
  name: "LayoutAdminPublic",

  components: { Layout }
};
</script>

<template>
  <layout>
    <template #slot-menu>
      <ul>
        <li>
          <router-link class="customer-login" :to="$t('r_page_login_url')">
            <span class="lockIcon"></span>
            {{ $t("r_page_customerLogin") }}
          </router-link>
        </li>
        <li>
          <a class="open-account" :href="$t('r_page_openAccount_url')">
            <span class="accountIcon"></span>
            {{ $t("r_page_openAccount") }}
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a :href="$t('r_page_vanfaxAdvantages_url')">
            {{ $t("r_page_vanfaxAdvantages") }}
          </a>
        </li>
        <li>
          <a :href="$t('r_page_rewardsProgram_url')">
            {{ $t("r_page_rewardsProgram") }}
          </a>
        </li>
        <li>
          <a :href="$t('r_page_productsCatalog_url')">
            {{ $t("r_page_productsCatalog") }}
          </a>
        </li>
        <li>
          <a :href="$t('r_page_warehouseLocator_url')">
            {{ $t("r_page_warehouseLocator") }}
          </a>
        </li>
        <li>
          <a :href="$t('r_page_ourPromotions_url')">
            {{ $t("r_page_ourPromotions") }}
          </a>
        </li>
        <li>
          <a :href="$t('r_page_newsletters_url')">
            {{ $t("r_page_newsletters") }}
            <font-awesome-icon
              icon="rss"
              class="text-red ml-2 vf-beat"
              style="--fa-animation-iteration-count: 20"
            />
          </a>
        </li>
        <li>
          <a :href="$t('r_page_careers_url')">
            {{ $t("r_page_careers") }}
          </a>
        </li>
      </ul>
    </template>
    <template #slot-main>
      <slot />
    </template>
  </layout>
</template>
